var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "186px",
    height: "186px",
    viewBox: "0 0 186 186",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp-number",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "whatsapp",
    transform: "translate(17.000000, 17.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.019,0 L75.981,0 C34.0765,0 0,34.086 0,76 C0,92.625 5.358,108.034 14.4685,120.5455 L4.997,148.7795 L34.2095,139.441 C46.227,147.402 60.5625,152 76.019,152 C117.9235,152 152,117.9045 152,76 C152,34.0955 117.9235,0 76.019,0 Z M120.2415,107.3215 C118.408,112.499 111.131,116.793 105.3265,118.047 C101.3555,118.8925 96.1685,119.567 78.7075,112.328 C56.373,103.075 41.99,80.3795 40.869,78.907 C39.7955,77.4345 31.844,66.8895 31.844,55.9835 C31.844,45.0775 37.3825,39.767 39.615,37.487 C41.4485,35.6155 44.479,34.7605 47.386,34.7605 C48.3265,34.7605 49.172,34.808 49.932,34.846 C52.1645,34.941 53.2855,35.074 54.758,38.5985 C56.5915,43.016 61.0565,53.922 61.5885,55.043 C62.13,56.164 62.6715,57.684 61.9115,59.1565 C61.199,60.6765 60.572,61.351 59.451,62.643 C58.33,63.935 57.266,64.923 56.145,66.31 C55.119,67.5165 53.96,68.8085 55.252,71.041 C56.544,73.226 61.009,80.5125 67.583,86.3645 C76.0665,93.917 82.9445,96.33 85.405,97.356 C87.2385,98.116 89.4235,97.9355 90.763,96.5105 C92.4635,94.677 94.563,91.637 96.7005,88.6445 C98.2205,86.4975 100.1395,86.2315 102.1535,86.9915 C104.2055,87.704 115.064,93.0715 117.2965,94.183 C119.529,95.304 121.0015,95.836 121.543,96.7765 C122.075,97.717 122.075,102.1345 120.2415,107.3215 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.eaeac5ba752922e75e63c8db75655684.svg";
export { ForwardRef as ReactComponent };